/**
 * @module app.core
 */

import { FrameworkConfiguration } from 'aurelia-framework';

export function configure(config: FrameworkConfiguration) {
  config.globalResources([
      // elements
      './elements/custom-edit',

      // value-converters
      './value-converters/custom-field-definition-value-converter'
  ]);
}
